(function () {
    'use strict';

    function searchConfigurationDataService($http, $q) {
        var baseUrl = '[BuildifyApiHost]/api/';

        function loadEntitiesSearch(index, workflowId) {
            if (index === "") {
                return $q.when(null);
            }
            var url = baseUrl + 'entitysearches/' + index + (workflowId ? '/workflows/' + workflowId : '');
            return $http.get(url).then(function (response) {
                return response.data;
            });
        };

        function loadProductDefinitionsSearch(index, projectId) {
            var url = baseUrl + 'productdefinitionsearches/' + index + (projectId ? '/' + projectId : '');
            return $http.get(url).then(function (response) {
                return response.data;
            });
        };

        return {
            loadEntitiesSearch: loadEntitiesSearch,
            loadProductDefinitionsSearch: loadProductDefinitionsSearch
        }
    }

    searchConfigurationDataService.$inject = ['$http', '$q'];

    angular.module('ecap.common').factory('searchConfigurationDataService', searchConfigurationDataService);
})();
